/** First advertised date: Tuesday 15 Sep 2026, 14:00–15:30. */
export const LAUNCH_COURSE_DATE = new Date(2026, 8, 15, 14, 0);
export const COURSE_TIME_LABEL = "14:00–15:30 Uhr";

/**
 * Returns the advertised course slot. Until two days before the launch date
 * that is 15.09.2026; afterwards the next Tuesday 14:00 with at least two
 * days of lead time, so the site never promotes a session that is about to start.
 */
export function getNextCourseDate(): { date: Date; timeLabel: string } {
  const now = new Date();
  const cutoff = new Date(LAUNCH_COURSE_DATE);
  cutoff.setDate(cutoff.getDate() - 2);
  if (now < cutoff) {
    return { date: LAUNCH_COURSE_DATE, timeLabel: COURSE_TIME_LABEL };
  }
  for (let offset = 2; offset <= 8; offset++) {
    const day = new Date(now.getFullYear(), now.getMonth(), now.getDate() + offset);
    if (day.getDay() === 2) {
      return {
        date: new Date(day.getFullYear(), day.getMonth(), day.getDate(), 14, 0),
        timeLabel: COURSE_TIME_LABEL,
      };
    }
  }
  return { date: LAUNCH_COURSE_DATE, timeLabel: COURSE_TIME_LABEL };
}

export function formatCourseDateLong(date: Date): string {
  return new Intl.DateTimeFormat("de-DE", {
    weekday: "long",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(date);
}

export function formatCourseDateShort(date: Date): string {
  return new Intl.DateTimeFormat("de-DE", {
    weekday: "short",
    day: "2-digit",
    month: "2-digit",
  }).format(date);
}

export function formatCourseDateBadge(date: Date): string {
  return new Intl.DateTimeFormat("de-DE", {
    day: "2-digit",
    month: "2-digit",
  }).format(date);
}
